module.exports = __webpack_public_path__ + "img/banner4.95c767b1.jpg";